import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


@Injectable({
    providedIn:'root'
})
export class FormControlsEventProxyService {

    private gmlEventSubject = new EventEmitter();
    //
    private gmltypeAEventSubject = new EventEmitter();
    private ltatypeAEventSubject = new EventEmitter();
    private ltaptypeAEventSubject = new EventEmitter();
    
    private gmltypeAradioEventSubject = new EventEmitter();    
    private ltatypeAradioEventSubject = new EventEmitter();    
    private ltaptypeAradioEventSubject = new EventEmitter(); 
    private gougestypeAradioEventSubject = new EventEmitter(); 
    private pittingtypeAradioEventSubject = new EventEmitter(); 
    private blisterhictypeAradioEventSubject = new EventEmitter(); 
    private crackliketypeAradioEventSubject = new EventEmitter(); 

    private denttypeAradioEventSubject = new EventEmitter(); 
    private dentgougetypeAradioEventSubject = new EventEmitter(); 
    private laminationstypeAradioEventSubject = new EventEmitter(); 
    //
    private inspectionDataEventSubject = new EventEmitter();   
    private MAWPEventSubject = new EventEmitter();   
     private MAEPEventSubject = new EventEmitter();   
    private mfhShellCourseBottomHeightEventSubject = new EventEmitter();
    private laminationsApplicabilityEventSubject = new EventEmitter();
    private ltaApplicabilityEventSubject = new EventEmitter();
    private ltatypeaApplicabilityEventSubject = new EventEmitter();
    
    private ltapApplicabilityEventSubject = new EventEmitter();
    private dentsApplicabilityEventSubject = new EventEmitter();
    private pittingApplicabilityEventSubject = new EventEmitter();
    private pittingInformationEventSubject = new EventEmitter(); 
    private gougesApplicabilityEventSubject = new EventEmitter();
    private gougestypeaApplicabilityEventSubject = new EventEmitter();
    private pittingtypeaApplicabilityEventSubject = new EventEmitter();
    private blisterhictypeaApplicabilityEventSubject = new EventEmitter();
    private denttypeaApplicabilityEventSubject = new EventEmitter();
    private dentgougetypeaApplicabilityEventSubject = new EventEmitter();
    private laminationstypeaApplicabilityEventSubject = new EventEmitter();

    private crackliketypeaApplicabilityEventSubject = new EventEmitter();

    private gougesDataEventSubject = new EventEmitter(); 
    private dentGougeApplicabilityEventSubject = new EventEmitter();
    private dentGougeComponentInformationEventSubject = new EventEmitter();
    private blisterAndHIC_ApplicabilityAndFormEventSubject = new EventEmitter();
    private crackLikeIndications_ApplicabilityAndFormEventSubject = new EventEmitter();
    private crackLikeIndicationsComponentInformationEventSubject = new EventEmitter();

    triggerGMLDataUpdateFormControlsEvent(){
        this.gmlEventSubject.emit();
    }
    //shameer-start
    triggerGMLtypeAFormControlsEvent(){
        this.gmltypeAEventSubject.emit();
    }
    getGMLtypeAApplicabilitySubject(): EventEmitter<any> {
        return this.gmltypeAEventSubject;
    }

    triggerltatypeAFormControlsEvent(){
        this.ltatypeAEventSubject.emit();
    }
    getltatypeAApplicabilitySubject(): EventEmitter<any> {
        return this.ltatypeAEventSubject;
    }

    triggerltaptypeAFormControlsEvent(){
        this.ltaptypeAEventSubject.emit();
    }
    getltaptypeAApplicabilitySubject(): EventEmitter<any> {
        return this.ltaptypeAEventSubject;
    }
    //shameer- end

     //shameer-start
     triggerGMLtypeAupdateradioFormControlsEvent(){
        this.gmltypeAradioEventSubject.emit();
    }
    getGMLtypeAupdateradioSubject(): EventEmitter<any> {
        return this.gmltypeAradioEventSubject;
    }

    triggerltatypeAupdateradioFormControlsEvent(){
        this.ltatypeAradioEventSubject.emit();
    }
    getltatypeAupdateradioSubject(): EventEmitter<any> {
        return this.ltatypeAradioEventSubject;
    }

    triggerltaptypeAupdateradioFormControlsEvent(){
        this.ltaptypeAradioEventSubject.emit();
    }
    getltaptypeAupdateradioSubject(): EventEmitter<any> {
        return this.ltaptypeAradioEventSubject;
    }

    triggergougestypeAupdateradioFormControlsEvent(){
        this.gougestypeAradioEventSubject.emit();
    }
    getgougestypeAupdateradioSubject(): EventEmitter<any> {
        return this.gougestypeAradioEventSubject;
    }

    triggerpittingtypeAupdateradioFormControlsEvent(){
        this.pittingtypeAradioEventSubject.emit();
    }
    getpittingtypeAupdateradioSubject(): EventEmitter<any> {
        return this.pittingtypeAradioEventSubject;
    }

    triggerblisterhictypeAupdateradioFormControlsEvent(){
        this.blisterhictypeAradioEventSubject.emit();
    }
    getblisterhictypeAupdateradioSubject(): EventEmitter<any> {
        return this.blisterhictypeAradioEventSubject;
    }

    triggercrackliketypeAupdateradioFormControlsEvent(){
        this.crackliketypeAradioEventSubject.emit();
    }
    getcrackliketypeAupdateradioSubject(): EventEmitter<any> {
        return this.crackliketypeAradioEventSubject;
    }

    triggerdenttypeAupdateradioFormControlsEvent(){
        this.denttypeAradioEventSubject.emit();
    }
    getdenttypeAupdateradioSubject(): EventEmitter<any> {
        return this.denttypeAradioEventSubject;
    }

    triggerdentgougetypeAupdateradioFormControlsEvent(){
        this.dentgougetypeAradioEventSubject.emit();
    }
    getdentgougetypeAupdateradioSubject(): EventEmitter<any> {
        return this.dentgougetypeAradioEventSubject;
    }

    triggerlaminationstypeAupdateradioFormControlsEvent(){
        this.laminationstypeAradioEventSubject.emit();
    }
    getlaminationstypeAupdateradioSubject(): EventEmitter<any> {
        return this.laminationstypeAradioEventSubject;
    }
    //shameer- end
    
    getGMLApplicabilityEventSubject(): EventEmitter<any> {
        return this.gmlEventSubject;
    }

    triggerInspectionDataEvent() {
        this.inspectionDataEventSubject.emit();   
    }

    getInspectionDataEventSubject(): EventEmitter<any> {
        return this.inspectionDataEventSubject;
    }

    triggerMAWPEvent() {
        this.MAWPEventSubject.emit();
    }

    getMAWPEventSubject(): EventEmitter<any> {
        return this.MAWPEventSubject;
    }

    triggerMfhShellCourseBottomHeightEvent() {
        this.mfhShellCourseBottomHeightEventSubject.emit();
    }

    getMfhShellCourseBottomHeightEventSubject(): EventEmitter<any> {
        return this.mfhShellCourseBottomHeightEventSubject;
    }

     triggerMAEPEvent() {
        this.MAEPEventSubject.emit();
    }

    getMAEPEventSubject(): EventEmitter<any> {
        return this.MAEPEventSubject;
    }

    triggerLaminationsApplicabilityCheckboxFormControlUpdateEvent() {
        this.laminationsApplicabilityEventSubject.emit();
    }

    getLaminationsApplicabilityEventSubject(): EventEmitter<any> {
        return this.laminationsApplicabilityEventSubject;
    }

    triggerLTA_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.ltaApplicabilityEventSubject.emit();
    }

    getLTA_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.ltaApplicabilityEventSubject;
    }

    //
    triggerLTA_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
        this.ltatypeaApplicabilityEventSubject.emit();
    }

    getLTA_TYPEAApplicabilityEventSubject(): EventEmitter<any> {
        return this.ltatypeaApplicabilityEventSubject;
    }

    //

    triggerLTAP_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.ltapApplicabilityEventSubject.emit();
    }

    getLTAP_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.ltapApplicabilityEventSubject;
    }

    triggerDents_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.dentsApplicabilityEventSubject.emit();
    }

    getDents_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.dentsApplicabilityEventSubject;
    }

    triggerPitting_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.pittingApplicabilityEventSubject.emit();
    }

    getPitting_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.pittingApplicabilityEventSubject;
    }

    triggerPittingInformationEvent() {
        this.pittingInformationEventSubject.emit();   
    }

    getPittingInformationEventSubject(): EventEmitter<any> {
        return this.pittingInformationEventSubject;
    }

    triggerGouges_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.gougesApplicabilityEventSubject.emit();
    }

    getGouges_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.gougesApplicabilityEventSubject;
    }

    triggerGougestypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.gougestypeaApplicabilityEventSubject.emit();
    }

    getGougestypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.gougestypeaApplicabilityEventSubject;
    }

    triggerPittingtypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.pittingtypeaApplicabilityEventSubject.emit();
    }

    getPittingtypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.pittingtypeaApplicabilityEventSubject;
    }

    triggerBlisterHICtypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.blisterhictypeaApplicabilityEventSubject.emit();
    }

    getBlisterHICtypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.blisterhictypeaApplicabilityEventSubject;
    }

    triggercrackliketypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.crackliketypeaApplicabilityEventSubject.emit();
    }

    getcrackliketypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.crackliketypeaApplicabilityEventSubject;
    }

    triggerDenttypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.denttypeaApplicabilityEventSubject.emit();
    }

    getDenttypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.denttypeaApplicabilityEventSubject;
    }

    triggerDentGougetypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.dentgougetypeaApplicabilityEventSubject.emit();
    }

    getDentGougetypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.dentgougetypeaApplicabilityEventSubject;
    }

    triggerLaminationstypea_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.laminationstypeaApplicabilityEventSubject.emit();
    }

    getLaminationstypea_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.laminationstypeaApplicabilityEventSubject;
    }

    triggerGougesDataEvent() {
        this.gougesDataEventSubject.emit();   
    }

    getGougesDataEventSubject(): EventEmitter<any> {
        return this.gougesDataEventSubject;
    }

    triggerDentGouge_ApplicabilityCheckboxFormControlUpdateEvent() {
        this.dentGougeApplicabilityEventSubject.emit();
    }

    getDentGouge_ApplicabilityEventSubject(): EventEmitter<any> {
        return this.dentGougeApplicabilityEventSubject;
    }

    triggerDentGouge_ComponentInformationEvent() {
        this.dentGougeComponentInformationEventSubject.emit();
    }

    getDentGouge_ComponentInformationEvent(): EventEmitter<any> {
        return this.dentGougeComponentInformationEventSubject;
    }

    triggerBlisterAndHIC_ApplicabilityCheckboxAndFormUpdateEvent() {
        this.blisterAndHIC_ApplicabilityAndFormEventSubject.emit();
    }

    getBlisterAndHIC_ApplicabilityAndFormEventSubject(): EventEmitter<any> {
        return this.blisterAndHIC_ApplicabilityAndFormEventSubject;
    }

    triggerCrackLikeIndications_ApplicabilityCheckboxAndFormUpdateEvent() {
        this.crackLikeIndications_ApplicabilityAndFormEventSubject.emit();
    }

    getCrackLikeIndications_ApplicabilityAndFormEventSubject(): EventEmitter<any> {
        return this.crackLikeIndications_ApplicabilityAndFormEventSubject;
    }

    triggerCrackLikeIndications_ComponentInformationEvent() {
        this.crackLikeIndicationsComponentInformationEventSubject.emit();
    }

    getCrackLikeIndications_ComponentInformationEvent(): EventEmitter<any> {
        return this.crackLikeIndicationsComponentInformationEventSubject;
    }

}